import {useState} from "react";
import {useSelector} from "react-redux";
import TeamNote from "./team-note";
import {normalizeMembershipEntity} from "../workspace-membership/workspace-membership-identity";

const populate = {
    team: true,
    author: {populate: {member: {populate: ["profileImage"]}}},
    archivedBy: {populate: {member: {populate: ["profileImage"]}}},
};

export function useTeamNote() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const membership = useSelector((state) => state.app.workspaceMembershipData);
    const memberships = membership?.workspace?.workspace_memberships || [];
    const normalize = (item) => normalizeMembershipEntity(item, "teamNote", memberships);

    const run = async (action) => {
        setLoading(true);
        setError(null);
        try { return await action(); }
        catch (requestError) { setError(requestError); throw requestError; }
        finally { setLoading(false); }
    };

    const getTeamNotes = (teamDocumentId) => run(async () => {
        const response = await new TeamNote().fetch(require("qs").stringify({
            filters: {team: {documentId: {$eq: teamDocumentId}}},
            populate,
            sort: ["updatedAt:desc"],
            pagination: {pageSize: 100},
        }, {encodeValuesOnly: true}));
        return (response?.data || []).map(normalize);
    });

    const createTeamNote = (data) => run(async () => normalize((await new TeamNote().create(data, {populate}))?.data));
    const updateTeamNote = (documentId, data) => run(async () => normalize((await new TeamNote().update(documentId, data, {populate}))?.data));
    const archiveTeamNote = (documentId) => run(async () => normalize((await new TeamNote().delete(documentId))?.data));

    return {getTeamNotes, createTeamNote, updateTeamNote, archiveTeamNote, loading, error};
}
